import { render, staticRenderFns } from "./PublicOverviewService.vue?vue&type=template&id=45776d88"
import script from "./PublicOverviewService.vue?vue&type=script&lang=js"
export * from "./PublicOverviewService.vue?vue&type=script&lang=js"
import style0 from "./PublicOverviewService.vue?vue&type=style&index=0&id=45776d88&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports